module.exports = __webpack_public_path__ + "static/img/section03-01@t.efd417e.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/omron-healthcare/section03-01@t.jpg
// module id = H6L7
// module chunks = 0